<template>
  <div>
    <!-- 基础设置 -->
    <!-- 商品属性 -->
    <div class="basicSettings-item">
      <div class="name">{{ $t('message.commodityAttribute') }}</div>
      <div class="row" v-for="(item, index) in typeList" :key="index">
        <div class="label">{{ item.name }}</div>
        <div class="value">
          <!-- 支持   -->
          <el-radio v-model="item.value" label="1" @change="setProductSupplyType">{{ $t('message.support') }}</el-radio>
          <!-- 不支持 -->
          <el-radio v-model="item.value" label="2" @change="setProductSupplyType"> {{ $t('message.noSupport')
          }}</el-radio>
        </div>
      </div>
    </div>
    <!-- 违禁品类别 -->
    <div class="basicSettings-item">
      <div class="name">{{ $t('message.categoryOfProhibitedItems') }}</div>
      <el-checkbox :label="item.value" v-for="(item, index) in forbidTypeList" :key="index" v-model="item.checked"
        @change="setProductForbidType" style="margin: 0 30px 24px 0;"></el-checkbox>
    </div>
    <!-- 捆包图 -->
    <div class="basicSettings-item">
      <div class="name">{{ $t('message.packingDiagram') }}</div>
      <el-upload action="https://jsonplaceholder.typicode.com/posts/" list-type="picture-card"
        :on-preview="handlePictureCardPreview" :on-remove="handleRemove" multiple drag :http-request="httpup"
        :file-list="detail.client_product_image_pack" :before-upload="befoUpload">
        <i class="el-icon-plus"></i>
      </el-upload>
    </div>
    <!-- 实物图 -->
    <div class="basicSettings-item">
      <div class="name">{{ $t('message.physicalImage') }}</div>
      <div class="table">
        <ol>
          <!-- 商品链接 -->
          <li>{{ $t('message.ProductLink') }}</li>
          <!-- 工产 -->
          <li>{{ $t('message.factory') }}</li>
          <!-- 商品图片 -->
          <li class="flex05">{{ $t('message.productPicture') }}</li>
          <!-- sku -->
          <li class="flex05">SKU</li>
          <!-- 状态 -->
          <li class="flex05">{{ $t('message.status') }}</li>
          <!-- 实物图上传 -->
          <li class="flex3">{{ $t('message.uploadPhysicalImage') }}</li>
        </ol>
        <ul v-for="(item, index) in detail.client_product_link" :key="index">
          <!-- 商品链接 -->
          <li>{{ }}
            <a :href="item.link.goods_url" target="_blank" rel="noopener noreferrer" class="a-link word-break">{{
              item.link.goods_url }}</a>
          </li>
          <!-- 工厂 -->
          <li>{{ item.item_sku.item.shop_name }}</li>
          <!-- 商品图片 -->
          <li class="flex05"> <el-image style="width: 120px;height: 120px;border-radius: 6px; " :src="item.pic"
              :preview-src-list="[item.pic]">
            </el-image></li>
          <!-- sku -->
          <li class="flex05">
            <div>
              <p v-for="(detail, detailIndex) in item.item_sku.detail" :key="detailIndex">
                {{ detail.key }} :{{ detail.value }}
              </p>
            </div>
          </li>
          <!-- 状态 -->
          <li class="flex05">
            {{ item.item_sku.is_on_sale == 1 ? '有库存' : '无库存' }}
          </li>
          <!-- 实物图上传 -->
          <li class="flex3">
            <div class="pic-box">
              <div class="upPic" @click="linkIndex = index">
                <el-upload action="https://jsonplaceholder.typicode.com/posts/" list-type="picture-card" multiple drag
                  :http-request="httpupLink" :show-file-list="false" :before-upload="befoUpload">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
              <!-- 图片列表 -->
              <div class="pic-list">
                <div class="img" v-for="(pic, picIndex) in item.client_product_image_real" :key="picIndex">
                  <img :src="pic.url" alt="">
                  <div class="btn">
                    <i class="el-icon-zoom-in" @click="handlePictureCardPreview(pic)"></i>
                    <i class="el-icon-delete" @click="delLinkPic(index, picIndex)"></i>
                  </div>
                </div>
              </div>
              <!-- 操作 -->
              <div class="synchronization">
                <!-- 同步 -->
                <el-button type="success" @click="imageLinkCheck(item)">{{ $t('message.synchronization') }}</el-button>
                <p style="margin-top: 50px;">
                  <!-- 图片公开 -->
                  <el-checkbox v-model="item.checked" @change="picturePublic(index, item.checked)">{{
                    $t('message.picturePublic') }}</el-checkbox>
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
export default {

  data() {
    return {
      checked: false,
      detail: {
        client_product_supply_type: [],
        forbid_type: [],
        client_product_image_pack: [],
        client_product_link: [],
      },
      forbidTypeList: [],
      checkList: [],
      typeList: [
        {
          name: '现货',
          value: '2',
        },
        {
          name: 'OEM',
          value: '2',
        },
        {
          name: 'ODM',
          value: '2',
        }
      ],

      dialogImageUrl: '',
      dialogVisible: false,
      linkIndex: 0, // 实物图索引
    };
  },
  created() {

  },
  methods: {
    // 设置数据
    setData(data) {
      this.detail = data
      this.detail.client_product_supply_type.forEach(item => {
        this.typeList.forEach(items => {
          if (item.type_name == items.name) {
            items.value = '1'
          }
        })
      })
      this.detail.client_product_link.forEach(item => {
        item.checked = item.client_product_image_real.every(items => items.is_hide == 0)
      })
      this.$api.siteConfiguration.forbidTypes().then(res => {
        res.data.forEach(item => {
          item.checked = false
          if (this.detail.forbid_type != null) {
            this.detail.forbid_type.forEach(items => {
              if (item.key == items.key) {
                item.checked = true
              }
            })
          }

        })
        this.forbidTypeList = res.data
      })
    },
    // 信息维护-数据维护-设置供货方式
    setProductSupplyType() {
      let datas = {
        user_id: this.detail.user_id,
        sys_code: this.detail.sys_code,
        type_name: [],
      }
      this.typeList.forEach(item => {
        if (item.value == 1) {
          datas.type_name.push(item.name)
        }
      })
      this.$api.productManagementApi.setProductSupplyType(datas)
      this.$forceUpdate()
    },
    //-设置商品违禁类型
    setProductForbidType() {
      let datas = {
        user_id: this.detail.user_id,
        sys_code: this.detail.sys_code,
        forbid_type: [],
      }
      this.forbidTypeList.forEach(item => {
        if (item.checked) {
          datas.forbid_type.push({
            key: item.key,
            value: item.value
          })
        }
      })
      this.$api.productManagementApi.setProductForbidType(datas)
    },
    handleRemove(file, fileList) {
      this.detail.client_product_image_pack = fileList
      this.imageUpdate()

    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    befoUpload(file) {
      const isPic =
        ["image/jpeg", "image/png", "image/jpg"].indexOf(file.type) != -1;
      if (!isPic) {
        if (file.name.indexOf('HEIC') == -1) {
          this.$message.error("请上传图片");
          return false
        }
      }
      return isPic;
    },
    // 上传
    async httpup(file) {
      const isPic =
        ["image/jpeg", "image/png", "image/jpg"].indexOf(file.file.type) != -1;
      if (!isPic) {
        return false
      }



      if (this.detail.client_product_image_pack.length > 6) return this.$message.error('图片最多只能上传6张')
      let data = await this.createClient(file)
      this.detail.client_product_image_pack.push({ url: data.data })
      this.imageUpdate()
    },
    //捆包图设置
    imageUpdate() {
      let list = []
      this.detail.client_product_image_pack.forEach(item => {
        list.push({
          type: 2,
          is_hide: 0,
          url: item.url
        })
      })
      let datas = {
        user_id: this.detail.user_id,
        sys_code: this.detail.sys_code,
        type: 2,
        list: list != false ? list : [],
      }
      this.$api.productManagementApi.imageUpdate(datas)
    },
    //实物图 上传
    async httpupLink(file) {
      const isPic =
        ["image/jpeg", "image/png", "image/jpg"].indexOf(file.file.type) != -1;
      if (!isPic) {
        return false
      }

      if (this.detail.client_product_link[this.linkIndex].client_product_image_real.length > 6) return this.$message.error('图片最多只能上传6张')
      let data = await this.createClient(file)
      this.detail.client_product_link[this.linkIndex].client_product_image_real.push({
        type: 1,
        is_hide: 0,
        url: data.data,
        link_id: this.detail.client_product_link[this.linkIndex].id
      })
      this.client_product_image_real()
      console.log(data);
    },
    //实物图设置
    client_product_image_real() {
      let datas = {
        user_id: this.detail.user_id,
        sys_code: this.detail.sys_code,
        type: 1,
        list: [],
      }
      this.detail.client_product_link.forEach(item => {
        datas.list = [...datas.list, ...item.client_product_image_real]
      })
      this.$api.productManagementApi.imageUpdate(datas)
    },
    // 删除
    delLinkPic(index, picIndex) {
      this.detail.client_product_link[index].client_product_image_real.splice(picIndex, 1)
      this.client_product_image_real()
    },
    // 图片是否公开
    picturePublic(index, checked) {
      this.detail.client_product_link[index].client_product_image_real.forEach(item => {
        item.is_hide = checked ? 0 : 1
      })
      this.$forceUpdate()
      this.client_product_image_real()
    },
    //同步
    imageLinkCheck(item) {
      let datas = {
        link_id_set: [item.id]
      }
      this.$api.productManagementApi.imageLinkCheck(datas).then(res => {
        let flag = false
        for (let key in res.data) {
          if (item.id == key) {
            flag = res.data[key]
          }
        }
        if (flag) {
          this.$api.productManagementApi.imageLinkSyncCheck(datas).then(res => {
            this.$message.success('同步成功')
            this.$parent.productList()
          })
        } else {
          this.$message.error('没有同步的实物图')
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.basicSettings-item {
  padding: 24px;
  border: 1px solid #dedede;
  border-radius: 6px;
  margin-bottom: 24px;

  .name {
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    margin-bottom: 24px;
  }

  .row {
    display: flex;
    line-height: 40px;
    margin-bottom: 24px;

    .label {
      width: 100px;
    }

    .value {
      flex: 1;
    }
  }

  /deep/.el-upload-dragger {
    width: auto;
    height: 118px;
    border: none;
  }
}

.table {
  li {
    justify-content: left;
    padding: 0 15px;
    position: relative;
  }

  .flex3 {
    flex: 3;
  }

  .flex05 {
    flex: 0.5;
  }

  ol {
    height: 56px;
  }

  ul {
    background-color: #fff;
    height: 130px;
    padding: 5px 0;
    border: none;
  }

  .pic-box {
    display: flex;
    width: 100%;

    .pic-list {
      width: 100px;
      flex: 1;
      margin: 0 30px;
      display: flex;
      flex-wrap: wrap;


      .img {
        position: relative;
        width: 60px;
        margin-right: 5px;

        &:hover {
          .btn {
            display: flex;
          }
        }

        .btn {
          position: absolute;
          top: 0;
          left: 0;
          width: 60px;
          height: 60px;
          background-color: rgba(0, 0, 0, 0.2);
          display: none;
          justify-content: center;
          align-items: center;
          border-radius: 5px;

          i {
            color: #fff;
            font-size: 18px;
            cursor: pointer;

            &:nth-last-child(1) {
              margin-left: 10px;
            }
          }
        }

        img {
          width: 60px;
          border-radius: 5px;
        }
      }
    }
  }
}
</style>